export const homeLb = {
  // Hero section
  heroTitle: "Si Kann. Si Wäert. Si Huet Et Gemaach.",
  heroSubtitle: "Eng Bewegung gebuer aus Widderstandsfäegkeet, gebaut fir all Fra déi jeemools gesot krut 'du kanns net.'",
  heroButton: "Bei Eiser Gemeinschaft Matmaachen",
  
  // Story section
  storyTitle: "Vum Kampf zur Stäerkt",
  storyText1: "SheCan ass aus menger eegener Rees gebuer fir Schwieregkeeten ze iwwerwannen. Als Fra déi onzielige Hindernisser konfrontéiert huet an méi dacks 'du kanns net' héieren huet wéi ech zielen kann, hunn ech decidéiert hinnen ze beweisen datt se falsch loungen.",
  storyText2: "Dës Bewegung ass fir all Fra déi ënnerschat, iwwersinn gouf oder där gesot gouf hir Dreem wieren ze grouss. Zesummen schreiwe mir d'Geschicht nei.",
  storyButton: "Meng Geschicht Liesen",
  
  // Community section
  communityTitle: "Gitt Mat Bei Enger Gemeinschaft Vun Onophaltsame Fraen",
  communitySubtitle: "Verbannen, wuessen a zesumme gedeien",
  communityFeature1: "Ënnerstëtzend Netzwierk",
  communityFeature1Text: "Verbannen Iech mat gläichgesënnten Fraen déi Är Rees verstinn",
  communityFeature2: "Exklusiv Evenementer",
  communityFeature2Text: "Zougang zu Workshops, Webinaren an Networking-Méiglechkeeten",
  communityFeature3: "Ressourcen & Handwierksgeschir",
  communityFeature3Text: "Kritt praktesch Ressourcen fir Iech ze hëllefen Är Ziler z'erreechen",
  communityButton: "Gemeinschaft Entdecken",
  
  // Featured Products
  productsTitle: "Stäerkt Är Rees",
  productsSubtitle: "Kuratéiert Produkter fir Iech ze inspiréieren an z'ënnerstëtzen",
  
  // Testimonials
  testimonialsTitle: "Geschichten Vun Transformatioun",
  testimonial1: "SheCan huet mir de Courage ginn mäin eegent Geschäft ze starten. D'Ënnerstëtzung vun der Gemeinschaft ass onglableg!",
  testimonial1Author: "Sarah Johnson",
  testimonial1Role: "Entrepreneurin",
  testimonial2: "Ech hunn meng Stëmm a mäi Stamm hei fonnt. Dës Bewegung huet mäi Liewen verännert.",
  testimonial2Author: "Maria Garcia",
  testimonial2Role: "Schrëftstellerin",
  testimonial3: "D'Ressourcen an d'Ënnerstëtzung hunn mir gehollef mäi Karriärewiessel mat Vertrauen ze navigéieren.",
  testimonial3Author: "Emily Chen",
  testimonial3Role: "Karriär-Coach"
};

export default homeLb;
